import styled, { css } from 'styled-components'

export const datItemStyles = css`
  --dat-accent: rgba(148, 163, 184, 0.34);
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  padding: 8px 10px 8px 13px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.58);
  overflow: hidden;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    box-shadow 160ms ease;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 2px;
    border-radius: 999px;
    background: var(--dat-accent);
  }

  &:hover {
    border-color: rgba(148, 163, 184, 0.18);
    background: rgba(15, 23, 42, 0.7);
  }

  &:focus-within {
    border-color: rgba(147, 197, 253, 0.24);
    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.08);
  }

  @media (max-width: 520px) {
    flex-wrap: wrap;
    align-items: stretch;
    gap: 7px;
    min-height: 0;
    padding: 7px 8px;
  }
`

export const DatItem = styled.label`
  ${datItemStyles}
`
